<template>
    <ul
        class="text-sm text-red-500 mb-4 list-inside"
        :class="{'list-disc': errorsForDisplay && errorsForDisplay.length > 1}"
    >
        <li
            v-for="(error, index) in errorsForDisplay"
            :key="index"
            v-text="error">
        </li>
    </ul>
</template>

<script>
import isString from 'lodash';

export default {
  name: 'FormFieldErrors',
  props: {
    errors: { type: [String, Array] },
  },
  data() {
    return {
      errorsForDisplay: isString(this.errors) ? [this.errors] : this.errors,
    };
  },
};
</script>

<style scoped>

</style>
